import React from "react";

import { useExternalProductOptions } from "shared/hooks/useExternalProductOptions";

import { Note } from "./styles";

interface ExternalProductOptionsSummaryProps {
    menuId: number;
    externalProductId: string | null;
}

// Сводка по опциям внешнего товара: сколько размеров, групп и модификаторов пришло
// из внешнего меню — чтобы было видно, что привязка вообще что-то даёт.
export const ExternalProductOptionsSummary = ({
    menuId,
    externalProductId,
}: ExternalProductOptionsSummaryProps) => {
    const { options, loading, error } = useExternalProductOptions(
        menuId,
        externalProductId,
        !!externalProductId
    );

    if (!externalProductId) return null;

    if (loading) return <Note>Загрузка опций…</Note>;

    if (error) return <Note $tone="danger">Не удалось загрузить опции</Note>;

    if (!options) return null;

    return (
        <Note>
            Размеры: {options.sizes.length}, группы модификаторов:{" "}
            {options.groupModifiers.length}, модификаторы: {options.modifiers.length}
        </Note>
    );
};
